// Scroll-positioning helpers for the thread body. Kept separate from the
// hook so the math is independently unit-testable.

import { SCROLL_TOP_OFFSET_PX } from '../constants';

/**
 * Scrolls `target`'s top edge to the top edge of `container` (minus a small
 * top offset). Uses a delta computed from `getBoundingClientRect` rather
 * than `scrollIntoView` so the outer document never accidentally scrolls
 * for partially-offscreen elements. No-op when the target is already
 * aligned within 1px.
 */
export const scrollMessageToTop = (
  container: HTMLElement,
  target: HTMLElement,
  topOffsetPx: number = SCROLL_TOP_OFFSET_PX,
  behavior: ScrollBehavior = 'smooth'
): void => {
  const delta =
    target.getBoundingClientRect().top -
    container.getBoundingClientRect().top -
    topOffsetPx;
  if (Math.abs(delta) < 1) return;
  container.scrollBy({ top: delta, behavior });
};
